<template>
  <!-- 화면을 가리는 오버레이 추가 -->
  <div v-if="showOverlay" class="screen-overlay">
    <img
        src="https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/d05c3b68-1e2f-443a-a162-90a0bcc4f000/fullpage"
        alt="overlay"
        class="overlay-image"
    />
  </div>

  <div class="component-container" v-safe-area-top :style="{ marginTop: containerMarginTop }">
    <div class="click-next-block"
         v-if="!requestSuccessful && !isInterpreting"
         @click="isProceedPopup = true"/>
    <div class="actual-text">
      <div class="actual-title-text serif font20 gray3">
        <span>앞의 해석 내용에 대한</span>
      </div>
      <div class="actual-sub-text serif font14 gray4">
        <span style="font-size: 22px;"><strong>한 가지 질문을 풀이해드릴게요</strong></span>
      </div>
    </div>

    <div class="text-field">
      <textarea
          ref="textareaRef"
          :value="question"
          @input="handleInput"
          @click="preventClick"
          @focus="handleFocus"
          @blur="handleBlur"
          class="text-field serif font18"
          maxlength="200"
          :placeholder="placeholderText"
          :disabled="isInterpreting || showOverlay"
          :readonly="isInterpreting || showOverlay"
      ></textarea>
      <div class="text-length">
        {{ textLength }}/200
      </div>
    </div>
    <transition name="slide-fade">
      <div
          v-if="!isWriting"
          v-wave
          class="request-button button-box"
          @click="handleButtonClick"
          :class="{ 'interpreting': isInterpreting || requestSuccessful, 'disabled': !isButtonEnabled || showOverlay }">
        <svg v-if="!isInterpreting"  width="193" height="24" viewBox="0 0 193 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.194 12.332L1.498 12.124L1.898 5.9H8.122V7.388H3.53L3.338 10.236C3.866 9.996 4.458 9.852 4.986 9.852C7.386 9.852 9.082 11.468 9.082 13.756C9.082 16.076 7.386 17.708 4.986 17.708C3.098 17.708 1.466 16.444 1.05 14.652L2.698 14.268C2.938 15.34 3.882 16.108 4.986 16.108C6.394 16.108 7.386 15.132 7.386 13.756C7.386 12.412 6.394 11.452 4.986 11.452C4.394 11.452 3.658 11.82 3.194 12.332ZM15.027 16.156C16.627 16.156 17.699 14.364 17.699 11.724C17.699 9.068 16.627 7.276 15.027 7.276C13.427 7.276 12.339 9.068 12.339 11.724C12.339 14.364 13.427 16.156 15.027 16.156ZM10.643 11.724C10.643 8.236 12.451 5.788 15.027 5.788C17.587 5.788 19.395 8.236 19.395 11.724C19.395 15.196 17.587 17.66 15.027 17.66C12.451 17.66 10.643 15.196 10.643 11.724ZM25.3239 16.156C26.9239 16.156 27.9959 14.364 27.9959 11.724C27.9959 9.068 26.9239 7.276 25.3239 7.276C23.7239 7.276 22.6359 9.068 22.6359 11.724C22.6359 14.364 23.7239 16.156 25.3239 16.156ZM20.9399 11.724C20.9399 8.236 22.7479 5.788 25.3239 5.788C27.8839 5.788 29.6919 8.236 29.6919 11.724C29.6919 15.196 27.8839 17.66 25.3239 17.66C22.7479 17.66 20.9399 15.196 20.9399 11.724ZM35.6208 16.156C37.2208 16.156 38.2928 14.364 38.2928 11.724C38.2928 9.068 37.2208 7.276 35.6208 7.276C34.0208 7.276 32.9328 9.068 32.9328 11.724C32.9328 14.364 34.0208 16.156 35.6208 16.156ZM31.2368 11.724C31.2368 8.236 33.0448 5.788 35.6208 5.788C38.1808 5.788 39.9888 8.236 39.9888 11.724C39.9888 15.196 38.1808 17.66 35.6208 17.66C33.0448 17.66 31.2368 15.196 31.2368 11.724ZM51.3896 4.54H53.1496V15.356H51.3896V14.092H48.6376V12.876H51.3896V4.54ZM41.2296 10.956C43.8376 10.94 47.3256 10.908 50.3496 10.54L50.4456 11.788C49.2936 11.98 48.0776 12.108 46.8936 12.188V14.924H45.1336V12.284C43.8216 12.348 42.5576 12.364 41.4536 12.364L41.2296 10.956ZM42.2856 7.58C42.2856 6.076 43.7416 5.068 45.8216 5.068C47.9176 5.068 49.3576 6.076 49.3576 7.58C49.3576 9.116 47.9176 10.108 45.8216 10.108C43.7416 10.108 42.2856 9.116 42.2856 7.58ZM43.1016 18.508V14.316H44.8616V17.1H53.4856V18.508H43.1016ZM43.9656 7.58C43.9656 8.364 44.7336 8.812 45.8216 8.812C46.9416 8.812 47.6776 8.364 47.6776 7.58C47.6776 6.796 46.9416 6.348 45.8216 6.348C44.7336 6.348 43.9656 6.796 43.9656 7.58Z" fill="#B2B2B2"/>
          <path d="M0.25 11.74H54.7496V12.54H0.25V11.74Z" fill="#B2B2B2"/>
          <path d="M77.3536 12.3536C77.5488 12.1583 77.5488 11.8417 77.3536 11.6464L74.1716 8.46447C73.9763 8.2692 73.6597 8.2692 73.4645 8.46447C73.2692 8.65973 73.2692 8.97631 73.4645 9.17157L76.2929 12L73.4645 14.8284C73.2692 15.0237 73.2692 15.3403 73.4645 15.5355C73.6597 15.7308 73.9763 15.7308 74.1716 15.5355L77.3536 12.3536ZM61 12.5L77 12.5V11.5L61 11.5V12.5Z" fill="#B2B2B2"/>
          <path d="M84.4339 4.48H94.4739V6.52H90.7139V7.66C90.7139 10.58 92.2539 13.66 95.1939 14.9L93.8339 16.86C91.7739 15.96 90.3139 14.16 89.5139 12C88.7139 14.36 87.2339 16.34 85.1339 17.3L83.7339 15.34C86.6739 14 88.2139 10.7 88.2139 7.66V6.52H84.4339V4.48ZM96.2139 20.68V2.76H98.6939V20.68H96.2139ZM103.374 3.56H115.654V4.98C115.654 6.42 115.654 7.94 115.254 10.02H117.594V12H101.374V10.02H112.794C113.174 8.2 113.234 6.82 113.234 5.54H103.374V3.56ZM103.274 20.5V13.94H115.594V20.5H103.274ZM105.694 18.52H113.174V15.86H105.694V18.52ZM130.395 2.76H132.875V9.78H135.495V11.84H132.875V20.68H130.395V2.76ZM118.755 7.4V5.42H122.755V3.04H125.255V5.42H129.215V7.4H118.755ZM119.495 12.72C119.495 10.22 121.415 8.46 124.015 8.46C126.615 8.46 128.555 10.22 128.555 12.72C128.555 15.2 126.615 16.96 124.015 16.96C121.415 16.96 119.495 15.2 119.495 12.72ZM121.875 12.72C121.875 14.1 122.755 14.94 124.015 14.94C125.275 14.94 126.175 14.1 126.175 12.72C126.175 11.32 125.275 10.46 124.015 10.46C122.755 10.46 121.875 11.32 121.875 12.72ZM137.055 4.2H145.495V5.6H148.795V2.76H151.295V15.8H148.795V11.42H145.495V12.92H137.055V4.2ZM139.455 20.34V14.58H141.955V18.36H151.675V20.34H139.455ZM139.495 10.96H143.075V6.14H139.495V10.96ZM145.495 9.44H148.795V7.58H145.495V9.44ZM158.425 12.82H174.645V14.8H167.705V20.7H165.225V14.8H158.425V12.82ZM160.305 10.84V3.64H172.685V10.84H160.305ZM162.725 8.92H170.265V5.62H162.725V8.92ZM175.906 16.64H180.046V13.84H177.786V7.86H187.826V5.88H177.746V3.92H190.286V9.8H180.226V11.86H190.686V13.84H188.146V16.64H192.126V18.66H175.906V16.64ZM182.486 16.64H185.726V13.84H182.486V16.64Z" fill="var(--tempGreen)"/>
        </svg>
        {{ isInterpreting ? '해석 중' : '🍀' }}

        <LoaderImage color="var(--loaderImage)"
                     v-if="isInterpreting"
                     style="margin-left: 8px;"
                     :size="12"
                     :speed="0.6"
                     :borderWidth="10" />
      </div>
    </transition>
  </div>

  <DialogPopup
      :isActive="isPopupShown"
      :closePopupCallback="() => { isPopupShown = false }"
      :request-successful="requestSuccessful"
      @request="$emit('request')"
      @close="isPopupShown = false"/>

  <ProceedPopup
      :isActive="isProceedPopup"
      :close="() => { isProceedPopup = false }"
      @next-pages="$emit('next-pages')"
      @close="isProceedPopup = false"/>

</template>

<script>

import DialogPopup from "@/tarot_box/pages/box_result_v2/components/Popups/DialogPopup.vue";
import LoaderImage from "@/tarot_box/components/LoaderImage.vue";
import {hideBottomBar, logEvent} from "@/tarot_box/helper/native_api";
import ProceedPopup from "@/tarot_box/pages/box_result_v2/components/Popups/ProceedPopup.vue";

export default {
  name: "extraQuestion",
  components: {ProceedPopup, LoaderImage, DialogPopup},
  props: {
    isOverlayVisible: {
      type: Boolean,
      default: false
    },
    currentIndex: {
      type: Number,
    },
    backgroundColor: {
      type: String,
    },
    currentChapterIndex: {
      type: Number,
    },
    currentPageData: {
      type: Object,
    },
    isShare: {
      type: Boolean,
    },
    isAnimationDone: {
      type: Boolean,
      default: false,
    },
    question: {
      type: String,
    },
    requestSuccessful: {
      type: Boolean,
    },
    isInterpreting: {
      type: Boolean,
    },
    lastAskedQuestion: {
      type: String,
    },
  },
  emits: ['animation-done', 'update:question', 'request', 'hide-bottom', 'show-bottom', 'next-pages'],
  data() {
    return {
      showOverlay: true, // 오버레이 표시 여부
      textLength: 0,
      showGuideText: false,
      showActualTitleText: false,
      showActualSubText: false,
      showTextField: false,
      showTextLength: false,
      showGuideText1: false,
      showGuideText2: false,
      isWriting: false,
      guideTexts: ['풀이는 어떠셨나요?', '아직 해소되지 않은 고민이 남아있나요?'],
      currentGuideTextIndex: 0,
      isAnimationPlayed: false,
      isQuestionInitiated: false,
      isPopupShown: false,
      isProceedPopup: false,
      isButtonEnabled: false,
      topPadding: 0,
    };
  },
  computed: {
    containerMarginTop() {
      return this.isShare ? '60px' : '114px';
    },
    placeholderText() {
      if (this.isInterpreting && this.lastAskedQuestion) {
        return this.lastAskedQuestion;
      } else {
        return "예시)\n- 미래 연인이 보는 내 첫 인상은?\n- 전 남친이 연락하면 어떻게 답장할까?";
      }
    }
  },
  watch: {
    question() {
      this.$nextTick(() => {
        this.resizeTextarea();
      });
    },
    textLength(newValue) {
      if (newValue > 0) {
        this.enableButton();
      } else {
        this.isButtonEnabled = false;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      logEvent('result_extra_question_into', {});
      if (this.question && this.question.length > 0) {
        this.resizeTextarea();
      }
    });
    if (this.isAnimationDone) {
      this.showAllComponents();
    } else {
      this.showAllComponents();
      // this.animateComponents();
    }
    if (this.requestSuccessful === true) {
      this.showAllComponents();
    }
    const newUrl = new URLSearchParams(window.location.href);
    this.topPadding = parseInt(newUrl.get('inset_top')) + 45 || 0;
  },
  beforeUnmount() {
  },
  methods: {
    hideBottomBar,
    animateComponents() {
      if (!this.isAnimationPlayed) {
        this.showGuideText1 = true;
        setTimeout(() => {
          this.showGuideText2 = true;
          setTimeout(() => {
            this.showGuideText1 = false;
            this.showGuideText2 = false;
            setTimeout(() => {
              this.showActualTitleText = true;
              setTimeout(() => {
                this.showActualSubText = true;
                this.showTextField = true;
                this.showTextLength = true;
                setTimeout(() => {
                  this.isAnimationPlayed = true;
                  this.$emit('animation-done');
                }, 1000);
              }, 3000);
            }, 500);
          }, 2000);
        }, 1000);
      }
    },
    showAllComponents() {
      this.showGuideText1 = false;
      this.showGuideText2 = false;
      this.showActualTitleText = true;
      this.showActualSubText = true;
      this.showTextField = true;
      this.showTextLength = true;
    },
    updateTextLength(event) {
      if (this.isQuestionInitiated === false) {
        this.isQuestionInitiated = true;
        logEvent('result_extra_question_input', {});
      }
      this.textLength = event.target.value.length;
    },
    openRequestPopup() {
      if (!this.showOverlay) {
        this.isPopupShown = true;
      }
    },
    preventClick(event) {
      if (this.isInterpreting || this.showOverlay) {
        event.preventDefault();
      }
    },
    handleFocus() {
      if (!this.showOverlay) {
        this.$emit('hide-bottom')
        this.isWriting = true;
      }
    },
    handleButtonClick() {
      if (this.isButtonEnabled && !this.isInterpreting && !this.showOverlay) {
        logEvent('result_extra_request_free_click', {});
        this.openRequestPopup();
      }
    },
    handleInput(event) {
      if (this.showOverlay) {
        event.preventDefault();
        return;
      }
      let newValue = event.target.value;
      const sanitizedValue = this.sanitizeInput(newValue);

      if (newValue !== sanitizedValue) {
        event.target.value = sanitizedValue;
      }

      this.$emit('update:question', sanitizedValue);
      this.updateTextLength({ target: { value: sanitizedValue } });
      this.resizeTextarea();
    },
    sanitizeInput(input) {
      // 줄바꿈 문자를 공백으로 대체
      let sanitized = input.replace(/\r\n|\r|\n/g, ' ');

      // 허용된 특수문자 정의
      const allowedSpecialChars = '.,?!-()·ㅡㆍ ᆢ ㅡㅣ';

      // 허용되지 않은 모든 문자 제거 (한글, 영문, 숫자, 허용된 특수문자 제외)
      sanitized = sanitized.replace(
          new RegExp(`[^\\sㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9${allowedSpecialChars}]`, 'g'),
          ''
      );

      // 연속된 공백을 하나의 공백으로 대체
      sanitized = sanitized.replace(/\s+/g, ' ');

      // 큰따옴표와 작은따옴표 제거
      sanitized = sanitized.replace(/['"]/g, '');

      // 최대 200자로 제한
      if (sanitized.length > 200) {
        sanitized = sanitized.slice(0, 200);
      }

      return sanitized;
    },
    resizeTextarea() {
      const textarea = this.$refs.textareaRef;
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
      }
    },
    handleBlur() {
      this.sanitizeInput(this.question);
      this.$emit('show-bottom');
      this.isWriting = false;
      let trimmedValue = this.question.trim();
      if (trimmedValue !== this.question) {
        this.$emit('update:question', trimmedValue);
        this.updateTextLength({ target: { value: trimmedValue } });
        this.resizeTextarea();
      }
    },
    enableButton() {
      this.isButtonEnabled = true;
    },
  },
};
</script>

<style scoped>
/* 화면을 가리는 오버레이 스타일 */
.screen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99; /* 모든 요소 위에 표시 */
  display: flex;
  align-items: center;
  background-image: linear-gradient(
      180deg,
      rgba(237, 241, 251, 0) 0%,
      rgba(237, 241, 251, 1) 100%);
  justify-content: center;
  pointer-events: auto; /* 클릭 이벤트를 막음 */
}

.overlay-image {
  width: 100%; /* 가로를 꽉 채움 */
  height: 100%;
  object-fit: contain; /* 이미지 비율 유지 */
}


.component-container {
  width: 100dvw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  margin-top: 60px;
}

.guide-text span {
  will-change: opacity, transform;
}

.actual-text{
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

.actual-title-text{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
}

.actual-sub-text{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 100%;
  box-sizing: border-box;
}

.text-field{
  position: relative;
  width: calc(100% - 40px);
  height: 100%;
  min-height: 120px;
  margin: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  text-align: left;
  color: var(--gray3);
}

.text-field::placeholder {
  color: var(--gray7);
}

.text-field textarea{
  margin: 0;
  padding: 20px;
  width: 100%;
  line-height: 24px;
  background: var(--textareafield);
  outline: 1px solid var(--gray10);
}

.text-length{
  display: flex;
  width: 100%;
  justify-content: flex-end;
  font-size: 14px;
  color: var(--gray3);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s, transform 1s;
  -webkit-transition: opacity 1s, transform 1s; /* Safari 전용 */

}

.fade-enter-from {
  opacity: 0;
  transform: translateY(20px);
  -webkit-transform: translateY(20px); /* Safari 전용 */

}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
  -webkit-transform: translateY(-20px); /* Safari 전용 */

}

.move-up {
  transform: translateY(-35px);
  transition: transform 0.5s;
}

.move-up2 {
  transform: translateY(-45px);
  transition: opacity 0s, transform 0s;
  transition-delay: 0s;
  margin-bottom: 20px;
  padding: 0;
  width: calc(100% - 40px);

}

.no-opacity-transition {
  transform: translateY(-45px);
  transition: opacity 0s, transform 0s;
  transition-delay: 0s;
}

.request-button{
  width: 90%;
  padding: 14px 0;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  font-size: 18px;
  font-weight: bold;
  transition: transform 0.3s ease;
}

.text-field textarea:disabled {
  background-color: transparent;
  cursor: default;
}

.request-button.interpreting {
  background-color: var(--buttonProcessing);
  cursor: default;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(calc(50vh));
  opacity: 0;
}

.click-next-block{
  position: absolute;
  width: 60px;
  height: 60px;
  background: transparent;
  bottom: 5px;
  right: 10px;
  z-index: 100;
}

.request-button.disabled {
  cursor: not-allowed;
}
</style>